import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-908b2bb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pptist-editor" }
const _hoisted_2 = {
  key: 0,
  class: "my-spin"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "my-spin"
}
const _hoisted_6 = {
  class: "loading",
  style: {"position":"relative","left":"auto","color":"#008aff"}
}
const _hoisted_7 = { style: {"position":"fixed","right":"10px","top":"10px","z-index":"9","cursor":"pointer"} }
const _hoisted_8 = {
  class: "bottom-tag",
  href: "/"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"height":"100%","width":"1px","background-color":"#fff","padding":"8px 0"} }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1752485668916",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "7713",
  width: "32",
  height: "32"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M288 128h608l-160 256 160 256H288v320H192V64h96v64z",
    "p-id": "7714",
    fill: "#ffffff"
  })
], -1))
const _hoisted_11 = { class: "layout-content-center" }
const _hoisted_12 = {
  name: "slide-fade",
  style: {"position":"relative"}
}
const _hoisted_13 = { class: "left_div" }

import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import {
  Modal,
  notification,
} from "ant-design-vue";

import { RightOutlined, LeftOutlined } from "@ant-design/icons-vue";
import { storeToRefs } from "pinia";
import { useMainStore, useSlidesStore } from "@/store";
import { Slide } from '@/types/slides'
import useGlobalHotkey from "@/hooks/useGlobalHotkey";
import usePasteEvent from "@/hooks/usePasteEvent";
import useSlideHandler from "@/hooks/useSlideHandler";
import {
  getPptShareAuth,
} from "@/api/combo";

import Canvas from "./Canvas/index.vue";
import Thumbnails from "./Thumbnails/index.vue";
import SelectPanel from "./SelectPanel.vue";
import { getQueryString } from "@/utils/common";
import useScreening from "@/hooks/useScreening";

import useCreateElement from "@/hooks/useCreateElement";

import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'tourists',
  setup(__props) {

const { createSlideByInfo, replaceSlide } = useSlideHandler();
const { t, locale } = useI18n();
const noPermissionShow = ref<Slide[]>([
  {
    "id": "Zkkf_lFQrR",
    "elements": [
      {
        "type": "text",
        "id": "gcxUml9Q70",
        "left": 260.59774020227553,
        "top": 41.44526311630847,
        "width": 442.4778761061947,
        "height": 128,
        "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 66px;\"><span style=\"font-family: &quot;STXinwei&quot;;\">aippttv</span></span></strong></p>",
        "rotate": 0,
        "defaultFontName": "Microsoft Yahei",
        "defaultColor": "rgba(255,255,255,1)",
        "vertical": false
      },
      {
        "type": "text",
        "id": "AIb3O4CrNT",
        "left": 127.054361567636,
        "top": 236.50916561314793,
        "width": 745.8912768647281,
        "height": 137,
        "content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 24px;\"><span style=\"font-family: &quot;STXinwei&quot;;\">CoNtEnT</span></span></strong></p>",
        "rotate": 0,
        "defaultFontName": "Microsoft Yahei",
        "defaultColor": "rgba(255,255,255,1)",
        "vertical": false
      }
    ],
    "background": {
      "type": "image",
      "color": "#fff",
      "image": "/uploadFile/102_1.jpg",
      "imageSize": "cover"
    }
  }
])
/* stop generate start */
const stop = ref(false);
const isEnd = ref(false);
const userSelectPreCatalogueId = ref(0);
const layoutContent: any = ref(null);
let index = 0;
const { enterScreening } = useScreening();
const waitTime = ref(0);
const reWaitTime = () => {
  waitTime.value = waitTime.value - 1;
  if (waitTime.value > 0) {
    setTimeout(function () {
      reWaitTime();
    }, 1000);
  }
};

const enterIconLoading = () => {
  if (waitTime.value === 0) {
    waitTime.value = 20;
    reWaitTime();
  }
  stop.value = true;
  spinning.value = false;
};

/* stop generate end */
const tip = ref(t(`index.createText`)); // '正在生成PPT文案'
const spinning = ref(false); //加载中
const errSpinning = ref(false);
const paid = ref();
const timer = ref();
const bg = ref();
const slideList = ref<any>([]);
const tokenOver = ref(false);
const pageSize = ref<number>(50);
const mouseenterFlag = ref(true);
const canChat = ref(false);
const isVip = ref(false);
const bodyWidth: any = ref();
const bodyHeight: any = ref();
const nowSize: any = ref();
const rightToolShow: any = ref(false);
const backgroundEditSate: any = ref(false);

onBeforeUnmount(() => {
  if (!timer.value) {
    spinning.value = false;
    clearInterval(timer.value);
  }
});

const changeToolShow = (data: boolean, type: number = 0): void => {
  backgroundEditSate.value = Boolean(type && data); //点击背景的展示背景编辑
  rightToolShow.value = data;
};

const ppt_start_Y: any = ref(0);
const pptTouchstart = (e: any) => {
  ppt_start_Y.value = e.touches[0].clientX;
};
const pptTouchend = (e: any) => {
  var ppt_end_Y = e.changedTouches[0].clientX;
  let len = slidesStore.slides.length;
  if (Math.abs(ppt_start_Y.value - ppt_end_Y) < 20) return;
  if (ppt_start_Y.value > ppt_end_Y && len > slideIndex.value + 1) {
    slidesStore.updateSlideIndex(slideIndex.value + 1);
  }
  if (ppt_start_Y.value < ppt_end_Y && slideIndex.value > 0) {
    slidesStore.updateSlideIndex(slideIndex.value - 1);
  }
};

onMounted(() => {
  mainStore.setIsPc(layoutContent.value.clientWidth > 767);
  nowSize.value = layoutContent.value.clientWidth;
  window.addEventListener("resize", () => {
    if (layoutContent.value) {
      nowSize.value = layoutContent.value.clientWidth;
      mainStore.setIsPc(layoutContent.value.clientWidth > 767);
    }
  });
  bodyWidth.value = layoutContent.value.clientWidth;
  bodyHeight.value = layoutContent.value.clientHeight;
  // 防止有PPT数据时刷新页面
  if (slidesStore.slideList.length !== 0) {
    spinning.value = false;
    isEnd.value = true;
    return;
  }
  const urlSearch = window.location.search;
  const shareId = getQueryString("shareId", urlSearch);
  if (!shareId) {
    notification["error"]({
      message: "System is busy.",
      // description: t("errorCode.errMsg"),
    });
    return;
  }
  mainStore.setIsTourist(Boolean(shareId));
  index = 1;
  getSliderList(shareId);
});

const getSliderList = async (id: any) => {
  if (isEnd.value) return;
  const res: any = await getPptShareAuth({
    id,
    pageNum: index,
    pageSize: pageSize.value,
  });
  const { code, data, total } = res;
  if (code === 200) {
    if (total === 0 || total === slideList.value.length || data.length == 0) {
      isEnd.value = true;
      spinning.value = false;
      slidesStore.setSlideList(slideList.value);
      slidesStore.slideIndex = 0;
      const thumbnailList = document.getElementById("thumbnails");
      if (thumbnailList) {
        thumbnailList.scrollTop = 0;
        thumbnailList.scrollLeft = 0;
      }
      return;
    }
    for (let i = 0; i < pageSize.value; i++) {
      const item = data[i];
      if (item && item.content) {
        const pptData = JSON.parse(item.content);
        if (pptData.background) {
          bg.value = pptData.background;
        } else {
          bg.value = {
            type: "solid",
            color: "#ffffff",
          };
        }
        pptData.elements.forEach((ele: any) => {
          ele.lock = true;
        });
        createSlideByInfo(pptData.id, pptData.elements, bg.value);
        if (index === 1) {
          slidesStore.slideIndex = i;
        } else {
          slidesStore.slideIndex = pageSize.value * (index - 1) + i;
        }
        tip.value = t(`index.createPage`, [index + 1]);
        slideList.value.push(pptData);
        const thumbnailList = document.getElementById("thumbnails");
        if (thumbnailList) {
          thumbnailList.scrollTop = thumbnailList.scrollHeight;
          thumbnailList.scrollLeft = thumbnailList.scrollWidth;
        }
        if (total === slideList.value.length) {
          slidesStore.setSlideList(slideList.value);
          slidesStore.slideIndex = 0;
        }
      }
    }
    if (data.length < pageSize.value) return;
    setTimeout(() => {
      index++;
      getSliderList(id);
    }, 1200);
  } else {
    let aftercontent = JSON.stringify(noPermissionShow.value).replace('CoNtEnT', t('public.noPermissionTips'))
    replaceSlide(JSON.parse(aftercontent))
    spinning.value = false;
  }
};


const mainStore = useMainStore();
const slidesStore = useSlidesStore();
const {
  showSelectPanel,
  activeElementIdList,
  isPc,
} = storeToRefs(mainStore);
const { slideIndex } = storeToRefs(slidesStore);
useGlobalHotkey();
usePasteEvent();

watch(activeElementIdList, () => {
  if (activeElementIdList.value.length !== 0) mainStore.setRedrawState(false);
});

function pushHistory() {
  var state = {
    title: "title",
    url: "#",
  };
  window.history.pushState(state, "title", "#");
}
pushHistory();
// 　　　　2.监听 popstate 事件
window.addEventListener(
  "popstate",
  function () {
    //doSomething
  },
  false
);



return (_ctx: any,_cache: any) => {
  const _component_IconPpt = _resolveComponent("IconPpt")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (spinning.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      (errSpinning.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, _toDisplayString(tip.value), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          title: _unref(t)(`editor.editorHeader.index.pptShow`)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              style: {"padding":"20px 15px"},
              class: "handler-item new_handler_item",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(enterScreening)()))
            }, [
              _createVNode(_component_IconPpt, {
                size: "25",
                fill: "#fff"
              })
            ])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _createElementVNode("div", {
        class: "layout-content",
        ref_key: "layoutContent",
        ref: layoutContent
      }, [
        _createElementVNode("a", _hoisted_8, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('public.bottomTag', { brand: 'WORKPPT' })), 1),
          _hoisted_9,
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", {
              class: _normalizeClass([
            _unref(isPc) ? 'new_layout_content_left' : 'new_layout_content_bottom',
          ])
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(Thumbnails)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass([
                _unref(isPc)
                  ? 'new_layout_content_rightTab'
                  : 'new_layout_content_topTab',
              ]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (mouseenterFlag.value = false))
                }, [
                  _createVNode(_unref(LeftOutlined))
                ], 2)
              ])
            ], 2)
          ], 512), [
            [_vShow, mouseenterFlag.value]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass([
          _unref(isPc)
            ? 'new_layout_content_leftTab'
            : 'new_layout_content_bottomTab',
        ]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (mouseenterFlag.value = true))
          }, [
            _createVNode(_unref(RightOutlined))
          ], 2), [
            [_vShow, !mouseenterFlag.value]
          ]),
          (_unref(isPc))
            ? (_openBlock(), _createBlock(Canvas, {
                key: 0,
                onChangeToolShow: changeToolShow,
                class: "center-body",
                userSelectPreCatalogueId: userSelectPreCatalogueId.value,
                isEnd: isEnd.value,
                paid: paid.value,
                canChat: canChat.value,
                isVip: isVip.value,
                style: _normalizeStyle({
            'margin-left': mouseenterFlag.value ? '220px' : '0px',
          })
              }, null, 8, ["userSelectPreCatalogueId", "isEnd", "paid", "canChat", "isVip", "style"]))
            : (_openBlock(), _createBlock(Canvas, {
                key: 1,
                onTouchstart: _cache[3] || (_cache[3] = ($event: any) => (pptTouchstart($event))),
                onTouchend: _cache[4] || (_cache[4] = ($event: any) => (pptTouchend($event))),
                class: "center-body",
                userSelectPreCatalogueId: userSelectPreCatalogueId.value,
                isEnd: isEnd.value,
                paid: paid.value,
                canChat: canChat.value,
                isVip: isVip.value,
                style: _normalizeStyle({
            height: mouseenterFlag.value ? 'calc(100% - 210px)' : 'calc(100% - 80px)',
            width: '100%',
            'margin-bottom': mouseenterFlag.value ? '80px' : '0px',
          })
              }, null, 8, ["userSelectPreCatalogueId", "isEnd", "paid", "canChat", "isVip", "style"]))
        ])
      ], 512)
    ]),
    (_unref(showSelectPanel))
      ? (_openBlock(), _createBlock(SelectPanel, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_unref(Modal), {
      visible: tokenOver.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((tokenOver).value = $event)),
      title: _unref(t)(`public.systemMsg`),
      onOk: _cache[6] || (_cache[6] = ($event: any) => (tokenOver.value = false)),
      cancelText: _unref(t)(`public.cancel`),
      "ok-text": "OK",
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(tip.value), 1)
      ]),
      _: 1
    }, 8, ["visible", "title", "cancelText"])
  ], 64))
}
}

})